import { deselectAllChats, toggleChatListPending } from '../chatList/actions';
import {
  TChatsBulkOperationsMoveToArchiveDesktopResponse,
  fetchChatsBulkOperationsMoveToArchiveDesktop,
} from '../../repositories/chats/v1/chats/bulk-operations/move-to-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Перенести чаты в архив
 * @param {string[]} chatIds массив id чатов
 */
export const archiveChats =
  (chatIds: string[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsMoveToArchiveDesktopResponse =
        await fetchChatsBulkOperationsMoveToArchiveDesktop({
          httpApi,
          parameters: {
            chatIds,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode === 200) {
        dispatch(deselectAllChats());
      } else {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось перенести чаты в архив',
          domain: 'src/shared/actions/chatList/archiveChats.ts',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: 'Не удалось перенести чаты в архив' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось перенести чаты в архив',
        domain: 'src/shared/actions/chatList/archiveChats.ts',
      });

      dispatch(showAlert({ message: 'Не удалось перенести чаты в архив' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
